exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js!./font.css"), "");
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js!./bass.css"), "");
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js!./component/index.css"), "");
// Module
exports.push([module.id, "body {\n  background-color: #f4f4f4;\n  font-family: \"Source Sans Pro\";\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.71;\n  letter-spacing: normal;\n  color: #3a3c42;\n}\n", ""]);
